import { Dispatch, SetStateAction } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Oval } from "react-loader-spinner";
import { SharedModals, TransactionsModals, PaymentModals, InvestmentTransactionModals, WithdrawalCardModals } from "@/constants/enums";

// Define Props as a generic type
type Props = {
  loadingText: string;
  showModal: SharedModals | TransactionsModals | PaymentModals | InvestmentTransactionModals | WithdrawalCardModals;
  setShowModal: Dispatch<SetStateAction<any>>;
  modalType: TransactionsModals.Loading | PaymentModals.Loading | InvestmentTransactionModals.Loading | WithdrawalCardModals.Loading;
};

// Make LoadingModal component generic
function LoadingModal({ showModal, setShowModal: _setShowModal, loadingText, modalType }: Props) {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      // This will be handled by the parent component
      // We don't close loading modals manually
    }
  };

  return (
    <Dialog open={showModal === modalType} onOpenChange={handleOpenChange}>
      <DialogContent className="px-6 max-w-xl max-h-[90vh] overflow-y-auto dark:bg-mfdarklight"
        onPointerDownOutside={(event) => {
          event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="sr-only">
            Loading
          </DialogTitle>
        </DialogHeader>
        {/* Main Content */}
        <div data-cy="loadingmodal-content" className="-mt-4 p-4">
          {/* Subtext */}
          <div className="mb-4">
            <div className="w-full flex justify-center">
              <Oval
                height={80}
                width={80}
                color="#EE5300"
                wrapperStyle={{}}
                wrapperClass=""
                visible
                ariaLabel='oval-loading'
                secondaryColor="#EE5300"
                strokeWidth={4}
                strokeWidthSecondary={4}
              />
            </div>
            {/* Loading text */}
            <p data-cy="loadingmodal-text" className="dark:text-white text-sm mt-6 text-center">
              {loadingText}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default LoadingModal;
